import {
    createAlleronaBasinContainer,
    createBellantiBasinContainer,
    createBouroBasinContainer,
    createDakotaBasinContainer,
    createFarraBasinContainer,
    createFloridaBasinContainer,
    createForzaBasinContainer,
    createIdroBasinContainer,
    createIndianaBasinContainer,
    createLesinaBasinContainer,
    createOraniBasinContainer,
    createOrtaBasinContainer,
    createSerrentiBasinContainer,
    createToledoBasinContainer,
    createTressaBasinContainer,
    createVinciBasinContainer,
} from "#pricing/catalogs/calypso/basins"
import type {TapHoleVariants} from "#pricing/catalogs/calypso/basins"
import type {CalypsoCatalog} from "#pricing/catalogs/calypso/catalog"
import {createPetraHandlesContainer} from "#pricing/catalogs/calypso/handles"
import {createPetraDecorLegsContainer} from "#pricing/catalogs/calypso/legs"
import {
    createAndrinaMirrorContainer,
    createMarbellaMirrorContainer,
    createMirrorContainer,
    createMurelloMirrorContainer,
    createOrbaMirrorContainer,
    createPetraMarbellaMirrorContainer,
    createVelasMirrorContainer,
    createVittoriaMirrorContainer,
} from "#pricing/catalogs/calypso/mirrors"
import type {MirrorFrameFinishVariant} from "#pricing/catalogs/calypso/mirrors"
import {
    createAquilaTapsContainer,
    createBuscaTapsContainer,
    createEulaTapsContainer,
    createFieraTapsContainer,
    createImolaTapsContainer,
    createLonatoTapsContainer,
    createLoriTapsContainer,
    createMelfiTapsContainer,
    tesimaAquilaTapMeshNames,
} from "#pricing/catalogs/calypso/taps"
import {
    createBrentaWallUnitContainer,
    createDiamanteTallWallUnitContainer,
    createForinoWallUnitContainer,
    createPetraTallWallUnitContainer,
} from "#pricing/catalogs/calypso/wall-units"
import {
    createCompactConcealedCisternContainer,
    createQuadraWcUnitContainer,
    createRimellaWcUnitContainer,
    createRiverdaleBtwPanContainer,
} from "#pricing/catalogs/calypso/wc-units"
import type {KeyedVariants, PriceGraphData} from "#pricing/catalogs/graph-helpers"
import {
    createAmountTriggeredPriceNode,
    createConditionedPriceNodes,
    createKeyedVariantPriceNodes,
    createPriceContainer,
    createVariantConditionedPriceNodes,
    variantSelected,
} from "#pricing/catalogs/graph-helpers"
import {ConfigurationGroupNode} from "#pricing/nodes/configuration-group-node"
import {MeshAmountNode} from "#pricing/nodes/mesh-amount-node"
import {MeshesNode} from "#pricing/nodes/meshes-node"

//Single entry point for the meshes currently present in the configurator scene; filled at runtime by the price graph accessor.
let Meshes = new MeshesNode({parameters: {meshes: []}})

let VanitySize = new ConfigurationGroupNode({
    parameters: {
        groupId: "Vanity",
        groupName: "Size",
        currentVariant: {groupId: "Vanity", groupName: "Size", variantId: "5685", variantName: "500"},
        allVariants: [],
    },
})
//5685, 500
//5686, 700
//5687, 900
//5768, 1000

let FurnitureFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "Furniturefinish",
        groupName: "Furniture Finish",
        currentVariant: {groupId: "Furniturefinish", groupName: "Furniture Finish", variantId: "CLW", variantName: "Coral White"},
        allVariants: [],
    },
})
//CLW, Coral White
//FIR, Fir Green
//MBK, Matt Black
//TOR, Tortona Oak
//SWH, Satin White
//SWE, Satin Weave
//SGY, Satin Grey

let WorktopFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "Worktopfinish",
        groupName: "Worktop Finish",
        currentVariant: {groupId: "Worktopfinish", groupName: "Worktop Finish", variantId: "CK", variantName: "Character Oak"},
        allVariants: [],
    },
})
//CK, Character Oak
//CR, Carrara White Marble
//PQ, Polar Quartz Matt

//The Diamante Calypstone worktops use their own configuration group, not the Worktopfinish one of the Tesima range.
let CalypstoneFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "WorktopFinish",
        groupName: "Worktop Finish",
        currentVariant: {groupId: "WorktopFinish", groupName: "Worktop Finish", variantId: "CS", variantName: "Cirrus White"},
        allVariants: [],
    },
})
//CS, Cirrus White
//MP, Imperial White
//SR, Stratus White

let AccessoryFinishes = new ConfigurationGroupNode({
    parameters: {
        groupId: "accsfin",
        groupName: "Accessory Finishes",
        currentVariant: {groupId: "accsfin", groupName: "Accessory Finishes", variantId: "CHR", variantName: "Chrome"},
        allVariants: [],
    },
})
//CHR, Chrome
//BBR, Brushed Brass
//BLK, Matt Black
//BBZ, Brushed Bronze
//GML, Gun Metal

let AdditionalUnits = new ConfigurationGroupNode({
    parameters: {
        groupId: "additionalunits",
        groupName: "Additional Units",
        currentVariant: {groupId: "additionalunits", groupName: "Additional Units", variantId: "Blank", variantName: "Vanity Only"},
        allVariants: [],
    },
})
//Blank, Vanity Only
//5688, Tall Wall Unit

let BasinType = new ConfigurationGroupNode({
    parameters: {
        groupId: "e069b5f6-f9d9-4182-b028-102f0ae967ac",
        groupName: "Basin Type",
        currentVariant: {groupId: "e069b5f6-f9d9-4182-b028-102f0ae967ac", groupName: "Basin Type", variantId: "sitonbasin700-900", variantName: "Siton Basins"},
        allVariants: [],
    },
})
//sitonbasin700-900, Siton Basins
//dc7a52b4-8f8d-49b7-bf80-c8e365c25c25, Forza Block Basin

let BasinFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "basinfinish",
        groupName: "Basin Finish",
        currentVariant: {groupId: "basinfinish", groupName: "Basin Finish", variantId: "9317", variantName: "White"},
        allVariants: [],
    },
})
//9317, White
//9318, Matt Black
//9282, Gloss White
//9283, Matt White
//9285, Matt Black

let TallWallUnitPosition = new ConfigurationGroupNode({
    parameters: {
        groupId: "wallunitposition",
        groupName: "Tall Wall Unit Position",
        currentVariant: {groupId: "wallunitposition", groupName: "Tall Wall Unit Position", variantId: "LH", variantName: "Left Hand"},
        allVariants: [],
    },
})
//LH, Left Hand
//RH, Right Hand

let UltimoFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "512cc53c-3a72-455d-974b-9aee87b2c27f",
        groupName: "Ultimo Finish",
        currentVariant: {groupId: "512cc53c-3a72-455d-974b-9aee87b2c27f", groupName: "Ultimo Finish", variantId: "PCW", variantName: "Porcelain White"},
        allVariants: [],
    },
})
//PCW, Porcelain White
//TOK, Tortona Oak

const vanitySizeConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["500", [VanitySize, "5685"]],
    ["700", [VanitySize, "5686"]],
    ["900", [VanitySize, "5687"]],
    ["1000", [VanitySize, "5768"]],
])

const furnitureFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Coral White", [FurnitureFinish, "CLW"]],
    ["Fir Green", [FurnitureFinish, "FIR"]],
    ["Matt Black", [FurnitureFinish, "MBK"]],
    ["Tortona Oak", [FurnitureFinish, "TOR"]],
    ["Satin White", [FurnitureFinish, "SWH"]],
    ["Satin Weave", [FurnitureFinish, "SWE"]],
    ["Satin Grey", [FurnitureFinish, "SGY"]],
])

const worktopFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Character Oak", [WorktopFinish, "CK"]],
    ["Carrara White Marble", [WorktopFinish, "CR"]],
    ["Polar Quartz Matt", [WorktopFinish, "PQ"]],
])

const calypstoneFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Cirrus White", [CalypstoneFinish, "CS"]],
    ["Imperial White", [CalypstoneFinish, "MP"]],
    ["Stratus White", [CalypstoneFinish, "SR"]],
])

const ultimoFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Porcelain White", [UltimoFinish, "PCW"]],
    ["Tortona Oak", [UltimoFinish, "TOK"]],
])

//The Ultimo range only offers porcelain white and tortona oak; catalog items shared with other ranges list further finishes.
const ultimoFinishExclude = ["Coral White", "Ember Gloss", "Fir Green", "Graphite", "Persian Walnut", "Soft Linen"]

//Concrete finishes are not offered by the configurator.
const worktopFinishExclude = ["Cool Concrete", "Warm Concrete"]

const accessoryFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Chrome", [AccessoryFinishes, "CHR"]],
    ["Brushed Brass", [AccessoryFinishes, "BBR"]],
    ["Matt Black", [AccessoryFinishes, "BLK"]],
    ["Gunmetal", [AccessoryFinishes, "GML"]],
    ["Brushed Bronze", [AccessoryFinishes, "BBZ"]],
])

//The Busca taps are the only items whose finish is resolved by SKU suffix instead of by description (see createBuscaTapsContainer).
//Customer decision (2026-09-16): for the Busca taps "Brushed Brass" is replaced by "Natural Brushed Brass", so the BBR variant
//prices the NBB row. The price is the same in both rows; only the article code changes. Every other product keeps BBR.
const buscaFinishSuffixMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["CHR", [AccessoryFinishes, "CHR"]],
    ["NBB", [AccessoryFinishes, "BBR"]],
    ["MBK", [AccessoryFinishes, "BLK"]],
    ["GML", [AccessoryFinishes, "GML"]],
    ["BBZ", [AccessoryFinishes, "BBZ"]],
])

//The Marbella mirror lives in one sub-template that several configurators use, but its "Mirror Frame" group is instanced per template,
//so the group and variant ids differ: Tesima has its own, Diamante and Ultimo share one. The group only exists while the accessory
//finish is not chrome.
const tesimaMirrorFrame = {
    group: new ConfigurationGroupNode({
        parameters: {
            groupId: "d845b8f5-4640-4c83-bde6-3b57c17b1ded",
            groupName: "Mirror Frame",
            currentVariant: {
                groupId: "d845b8f5-4640-4c83-bde6-3b57c17b1ded",
                groupName: "Mirror Frame",
                variantId: "bbaa7f15-b2f5-4b08-a758-1e1f17dd8887",
                variantName: "Plain",
            },
            allVariants: [],
        },
    }),
    withFrameVariantId: "2160b590-37c1-4a76-803d-f9edfb2c0e2c",
}

const diamanteUltimoMirrorFrame = {
    group: new ConfigurationGroupNode({
        parameters: {
            groupId: "2940d28d-fac8-431b-b75d-848baba6cb0f",
            groupName: "Mirror Frame",
            currentVariant: {
                groupId: "2940d28d-fac8-431b-b75d-848baba6cb0f",
                groupName: "Mirror Frame",
                variantId: "34c88fd1-b8a8-4ec9-8383-eb220c9b2257",
                variantName: "Plain",
            },
            allVariants: [],
        },
    }),
    withFrameVariantId: "e54757bf-761a-4288-bb07-0f3e850a5f2e",
}

//Gunmetal and brushed bronze have no framed Marbella; the template shows them unframed, so they fall through to the plain SKU. The
//BBR variant does show a brass frame and prices as gold; the catalog Marbella exists in brushed brass only, so unlike the Busca taps
//the frame is not affected by the natural brushed brass replacement.
const marbellaFrameFinishVariants: {gold: MirrorFrameFinishVariant[]; black: MirrorFrameFinishVariant[]} = {
    gold: [[AccessoryFinishes, "BBR"]],
    black: [[AccessoryFinishes, "BLK"]],
}

export function createTesimaGraph(catalog: CalypsoCatalog): PriceGraphData {
    const result: PriceGraphData = {
        amountGroups: [],
        pricedItemNodes: [],
        priceContainers: [],
    }

    //TODO: replace vanity units and worktops with mesh triggers

    //500 always has a sit-on basin (no Forza option), so no BasinType gate is needed.
    const worktop500Units = createVariantConditionedPriceNodes(
        catalog,
        ["Worktop (Square Edged)", "515 x 465"],
        3,
        worktopFinishConfigMap,
        undefined,
        worktopFinishExclude,
    )

    const tesima500Units = createVariantConditionedPriceNodes(catalog, ["Tesima WH Vanity Unit - 2 Drawer", "500 "], 4, furnitureFinishConfigMap)
    const tesima500Container = createPriceContainer("500", "500", [...tesima500Units, ...worktop500Units])
    tesima500Container.addDependency(VanitySize, "5685", "")
    result.priceContainers.push(tesima500Container)

    const worktop700Units = createVariantConditionedPriceNodes(
        catalog,
        ["Worktop (Square Edged)", "715 x 465"],
        3,
        worktopFinishConfigMap,
        undefined,
        worktopFinishExclude,
    )
    worktop700Units.forEach((node) => node.addDependency(BasinType, "sitonbasin700-900", ""))

    const tesima700Units = createVariantConditionedPriceNodes(catalog, ["Tesima WH Vanity Unit - 2 Drawer", "700 "], 4, furnitureFinishConfigMap)
    const tesima700Container = createPriceContainer("700", "700", [...tesima700Units, ...worktop700Units])
    tesima700Container.addDependency(VanitySize, "5686", "")
    result.priceContainers.push(tesima700Container)

    const worktop900Units = createVariantConditionedPriceNodes(
        catalog,
        ["Worktop (Square Edged)", "915 x 465"],
        3,
        worktopFinishConfigMap,
        undefined,
        worktopFinishExclude,
    )
    worktop900Units.forEach((node) => node.addDependency(BasinType, "sitonbasin700-900", ""))

    const tesima900Units = createVariantConditionedPriceNodes(catalog, ["Tesima WH Vanity Unit - 2 Drawer", "900 "], 4, furnitureFinishConfigMap)
    const tesima900Container = createPriceContainer("900", "900", [...tesima900Units, ...worktop900Units])
    tesima900Container.addDependency(VanitySize, "5687", "")
    result.priceContainers.push(tesima900Container)

    const tesima1000Units = createVariantConditionedPriceNodes(catalog, ["Tesima WH Vanity Unit - 2 Drawer", "1000 "], 4, furnitureFinishConfigMap)
    const worktop1000Units = createVariantConditionedPriceNodes(catalog, "3287", 1)
    worktop1000Units[0].addDependency(VanitySize, "5768", "")
    const tesima1000Container = createPriceContainer("1000", "1000", [...tesima1000Units, ...worktop1000Units])
    tesima1000Container.addDependency(VanitySize, "5768", "")
    result.priceContainers.push(tesima1000Container)

    //The basins are triggered by mesh presence, which covers both the basin type selection and the basin count: only the
    //selected basin's mesh exists in the scene, and the "2 Basins" location of the 1000mm unit adds a second mesh.
    //TODO: two sit-on basins share one Basin Finish variant, so they can't be priced in different finishes.
    result.priceContainers.push(createBellantiBasinContainer(catalog, Meshes))
    result.priceContainers.push(createFloridaBasinContainer(catalog, Meshes))
    result.priceContainers.push(createDakotaBasinContainer(catalog, Meshes))
    result.priceContainers.push(createIndianaBasinContainer(catalog, Meshes, BasinFinish))
    result.priceContainers.push(createToledoBasinContainer(catalog, Meshes, BasinFinish))
    result.priceContainers.push(createForzaBasinContainer(catalog, Meshes))

    //The taps are triggered by mesh presence, which implicitly covers the tap type and basin count selections: only the
    //selected tap's mesh exists in the scene, and a second basin adds a second mesh.
    result.priceContainers.push(createLoriTapsContainer(catalog, Meshes))
    result.priceContainers.push(createMelfiTapsContainer(catalog, Meshes))
    result.priceContainers.push(createImolaTapsContainer(catalog, Meshes, accessoryFinishConfigMap))
    result.priceContainers.push(createFieraTapsContainer(catalog, Meshes, accessoryFinishConfigMap))
    result.priceContainers.push(createEulaTapsContainer(catalog, Meshes, accessoryFinishConfigMap))
    result.priceContainers.push(createBuscaTapsContainer(catalog, Meshes, buscaFinishSuffixMap))
    result.priceContainers.push(createAquilaTapsContainer(catalog, Meshes, accessoryFinishConfigMap))

    //The "350 x 380 x 1500" term drops the stray 7884.56/57 duplicate rows, leaving the 5688* family of four.
    const tallWallUnitUnits = createVariantConditionedPriceNodes(catalog, ["Tesima Tall Wall Unit + Drawer", "350 x 380 x 1500"], 4, furnitureFinishConfigMap)
    const tallWallUnitContainer = createPriceContainer("Tall Wall Unit", "Tall Wall Unit", tallWallUnitUnits)
    tallWallUnitContainer.addDependency(AdditionalUnits, "5688", "")
    result.priceContainers.push(tallWallUnitContainer)

    result.priceContainers.push(createMirrorContainer(catalog, Meshes))
    result.priceContainers.push(createMarbellaMirrorContainer(catalog, Meshes, tesimaMirrorFrame, marbellaFrameFinishVariants))

    return result
}

export function createUltimoGraph(catalog: CalypsoCatalog): PriceGraphData {
    const result: PriceGraphData = {
        amountGroups: [],
        pricedItemNodes: [],
        priceContainers: [],
    }

    //The vanity units are triggered by mesh presence, the finish by the config variant. Both must hold for a node to price.
    //The catalog also lists 7802/7803 with identical descriptions and prices; the SKU stems from the mesh names are used.
    const ultimo900Amount = new MeshAmountNode({parameters: {name: "5643 - Ultimo WH Vanity Unit 900mm 2 Drawer 2 Door", meshes: Meshes}})
    const ultimo900Units = createVariantConditionedPriceNodes(catalog, "5643", 2, ultimoFinishConfigMap, ultimo900Amount)

    const ultimo1210Amount = new MeshAmountNode({parameters: {name: "5513 - Ultimo WH Vanity Unit 1210mm 2 Drawer 2 Door", meshes: Meshes}})
    const ultimo1210Units = createVariantConditionedPriceNodes(catalog, "5513", 2, ultimoFinishConfigMap, ultimo1210Amount)

    result.priceContainers.push(createPriceContainer("Vanity Units", "Vanity Units", [...ultimo900Units, ...ultimo1210Units], true))

    result.priceContainers.push(createMirrorContainer(catalog, Meshes))
    result.priceContainers.push(createMarbellaMirrorContainer(catalog, Meshes, diamanteUltimoMirrorFrame, marbellaFrameFinishVariants))

    result.priceContainers.push(createLesinaBasinContainer(catalog, Meshes))
    result.priceContainers.push(createTressaBasinContainer(catalog, Meshes))

    result.priceContainers.push(createRimellaWcUnitContainer(catalog, Meshes, ultimoFinishConfigMap, 2, ultimoFinishExclude))
    //TODO: the fluted Forino is left unpriced for now; the catalog has no porcelain white one (5841PCW).
    result.priceContainers.push(createForinoWallUnitContainer(catalog, Meshes, ultimoFinishConfigMap, {smooth: 2}, ultimoFinishExclude))

    result.priceContainers.push(createLoriTapsContainer(catalog, Meshes))
    result.priceContainers.push(createMelfiTapsContainer(catalog, Meshes))
    result.priceContainers.push(createImolaTapsContainer(catalog, Meshes, accessoryFinishConfigMap))
    result.priceContainers.push(createFieraTapsContainer(catalog, Meshes, accessoryFinishConfigMap))
    result.priceContainers.push(createEulaTapsContainer(catalog, Meshes, accessoryFinishConfigMap))
    result.priceContainers.push(createBuscaTapsContainer(catalog, Meshes, buscaFinishSuffixMap))
    result.priceContainers.push(createAquilaTapsContainer(catalog, Meshes, accessoryFinishConfigMap))

    return result
}

//The Brenta template uses its own furniture finish group, not the Furniturefinish one of the Tesima range.
let BrentaFurnitureFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "furniture-finish",
        groupName: "Furniture Finish",
        currentVariant: {groupId: "furniture-finish", groupName: "Furniture Finish", variantId: "pearly-white", variantName: "Pearly White"},
        allVariants: [],
    },
})
//pearly-white, Pearly White
//carrara-white-marble, Portland Stone
//midnight-cloud, Midnight Cloud
//warm-sage, Warm Sage
//sienna-oak, Sienna Oak
//nordic-oak, Nordic Oak

let BrentaVanitySize = new ConfigurationGroupNode({
    parameters: {
        groupId: "vanity-size",
        groupName: "Vanity Size",
        currentVariant: {groupId: "vanity-size", groupName: "Vanity Size", variantId: "600-two-drawer", variantName: "600 Two Drawer"},
        allVariants: [],
    },
})
//600-two-drawer, 600 Two Drawer
//800-two-drawer, 800 Two Drawer
//bf9ac998-bcd3-425c-952f-9412af8c842f, 1200 Four Drawer

//The template has one basin finish group per basin (same group id and variants); only the one of the selected basin is active.
let BrentaBasinFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "basin-finish",
        groupName: "Basin Finish",
        currentVariant: {groupId: "basin-finish", groupName: "Basin Finish", variantId: "gloss", variantName: "Gloss"},
        allVariants: [],
    },
})
//gloss, Gloss
//matt, Matt

//The tap type of the vanity basins decides between the one tap hole (mono taps) and no tap hole (wall mounted taps) basin SKUs.
let BrentaTapType = new ConfigurationGroupNode({
    parameters: {
        groupId: "495433dc-55a3-4289-b913-e63065e2e8a3",
        groupName: "Tap Type",
        currentVariant: {groupId: "495433dc-55a3-4289-b913-e63065e2e8a3", groupName: "Tap Type", variantId: "mono_basin_taps", variantName: "Mono Basin Taps"},
        allVariants: [],
    },
})
//mono_basin_taps, Mono Basin Taps
//wm_basin_taps, Wall Mounted Basin Taps

const brentaTapHoleVariants: TapHoleVariants = {group: BrentaTapType, oneTapHole: "mono_basin_taps", noTapHole: "wm_basin_taps"}

const brentaBasinFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Gloss White", [BrentaBasinFinish, "gloss"]],
    ["Matt White", [BrentaBasinFinish, "matt"]],
])

const brentaFurnitureFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Pearly White", [BrentaFurnitureFinish, "pearly-white"]],
    ["Portland Stone", [BrentaFurnitureFinish, "carrara-white-marble"]],
    ["Midnight Cloud", [BrentaFurnitureFinish, "midnight-cloud"]],
    ["Warm Sage", [BrentaFurnitureFinish, "warm-sage"]],
    ["Sienna Oak", [BrentaFurnitureFinish, "sienna-oak"]],
    ["Nordic Oak", [BrentaFurnitureFinish, "nordic-oak"]],
])

//The template has one accessory finish group per tap family with different group ids: metal-finish-3 (Busca: chrome, black, brass),
//metal-finish-2 (Imola: chrome, black) and metal-finish-1 (Lori: chrome only, no node needed). Each tap container gets its own map.
let BrentaBuscaAccessoryFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "metal-finish-3",
        groupName: "Accessory Finish",
        currentVariant: {groupId: "metal-finish-3", groupName: "Accessory Finish", variantId: "chrome", variantName: "Chrome"},
        allVariants: [],
    },
})
//chrome, Chrome
//black, Black
//brass, Brass

let BrentaImolaAccessoryFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "metal-finish-2",
        groupName: "Accessory Finish",
        currentVariant: {groupId: "metal-finish-2", groupName: "Accessory Finish", variantId: "chrome", variantName: "Chrome"},
        allVariants: [],
    },
})
//chrome, Chrome
//black, Black

//The Busca taps are resolved by SKU suffix (see createBuscaTapsContainer). The template offers three of the six catalog finishes;
//gunmetal (GML) and brushed bronze (BBZ) are simply absent from the map. The "brass" variant prices the natural brushed brass row
//(customer decision, 2026-09-16: "Brushed Brass" is replaced by "Natural Brushed Brass"); both rows carry the same price.
const brentaBuscaFinishSuffixMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["CHR", [BrentaBuscaAccessoryFinish, "chrome"]],
    ["MBK", [BrentaBuscaAccessoryFinish, "black"]],
    ["NBB", [BrentaBuscaAccessoryFinish, "brass"]],
])

const brentaImolaAccessoryFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Chrome", [BrentaImolaAccessoryFinish, "chrome"]],
    ["Matt Black", [BrentaImolaAccessoryFinish, "black"]],
])

//The template has one worktop finish group per worktop size (same group id and variants); only the one of the placed worktop is active.
let BrentaWorktopFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "undermount-worktop-finish",
        groupName: "Worktop Finish",
        currentVariant: {groupId: "undermount-worktop-finish", groupName: "Worktop Finish", variantId: "polar-quartz-matt", variantName: "Polar Quartz Matt"},
        allVariants: [],
    },
})
//polar-quartz-matt, Polar Quartz Matt
//carrara-white-marble, Carrara White Marble
//character-oak, Character Oak

const brentaWorktopFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Polar Quartz Matt", [BrentaWorktopFinish, "polar-quartz-matt"]],
    ["Carrara White Marble", [BrentaWorktopFinish, "carrara-white-marble"]],
    ["Character Oak", [BrentaWorktopFinish, "character-oak"]],
])

//Square edged worktop finishes not offered by the template.
const brentaWorktopFinishExclude = ["Breccia Light Marble", "Black Fusion", "Cool Concrete", "Gold Portoro", "Grey Fusion", "Warm Concrete", "White Fusion"]

//Mapping status and decisions: brenta.mapping.md
export function createBrentaGraph(catalog: CalypsoCatalog): PriceGraphData {
    const result: PriceGraphData = {
        amountGroups: [],
        pricedItemNodes: [],
        priceContainers: [],
    }

    //The vanity units are triggered by mesh presence, the finish by the furniture finish variant. The 1200 four drawer vanity is built
    //from two 600 meshes in the template, but sold as kit 4817 (the full list describes it as 600mm; "Ammendments from V1" corrects it
    //to 1200 x 460 x 520mm; confirmed by the customer). Since 600 and 1200 share the mesh, the vanity size variant decides between 4722
    //and 4817.
    const brenta600Amount = new MeshAmountNode({parameters: {name: "4722 - Brenta WH Vanity Unit 600mm", meshes: Meshes}})
    const brenta600Units = createVariantConditionedPriceNodes(catalog, "4722", 6, brentaFurnitureFinishConfigMap, brenta600Amount)
    brenta600Units.forEach((node) => node.addDependency(BrentaVanitySize, "600-two-drawer", ""))

    const brenta800Amount = new MeshAmountNode({parameters: {name: "4723 - Brenta WH Vanity Unit 800mm", meshes: Meshes}})
    const brenta800Units = createVariantConditionedPriceNodes(catalog, "4723", 6, brentaFurnitureFinishConfigMap, brenta800Amount)

    const brenta1200Units = createVariantConditionedPriceNodes(catalog, "4817", 6, brentaFurnitureFinishConfigMap)
    brenta1200Units.forEach((node) => node.addDependency(BrentaVanitySize, "bf9ac998-bcd3-425c-952f-9412af8c842f", ""))

    result.priceContainers.push(createPriceContainer("Vanity Units", "Vanity Units", [...brenta600Units, ...brenta800Units, ...brenta1200Units], true))

    //The worktops only exist with the sit-on basin. They are triggered by mesh presence, the finish by the worktop finish variant. The meshes
    //are named "Cast Marble", but their materials are "Square Edged - <finish>", so the square edged worktops of the next size up are used
    //(615 / 815 x 465mm). The 1200 is the exception: the only 1210mm worktop is the cast marble one, which exists in matt white only, so it
    //is priced by mesh alone (confirmed by the customer, the configurator offers no other 1200 worktop finish).
    const brentaWorktop600Amount = new MeshAmountNode({parameters: {name: "Worktop - Cast Marble - 61 x 46,5 x 1,5cm", meshes: Meshes}})
    const brentaWorktop600Units = createVariantConditionedPriceNodes(
        catalog,
        ["Worktop (Square Edged)", "615 x 465"],
        3,
        brentaWorktopFinishConfigMap,
        brentaWorktop600Amount,
        brentaWorktopFinishExclude,
    )

    const brentaWorktop800Amount = new MeshAmountNode({parameters: {name: "Worktop - Cast Marble - 81 x 46,5 x 1,5cm", meshes: Meshes}})
    const brentaWorktop800Units = createVariantConditionedPriceNodes(
        catalog,
        ["Worktop (Square Edged)", "815 x 465"],
        3,
        brentaWorktopFinishConfigMap,
        brentaWorktop800Amount,
        brentaWorktopFinishExclude,
    )

    const brentaWorktop1200Amount = new MeshAmountNode({parameters: {name: "Worktop - Cast Marble - 121 x 46,5 x 1,5cm", meshes: Meshes}})
    const brentaWorktop1200 = createAmountTriggeredPriceNode(catalog, "3288", brentaWorktop1200Amount)

    result.priceContainers.push(createPriceContainer("Worktops", "Worktops", [...brentaWorktop600Units, ...brentaWorktop800Units, brentaWorktop1200], true))

    //The basins are triggered by mesh presence, the finish by the basin finish variant and the tap hole by the tap type. The 1200 vanity
    //places two Bellanti meshes; Bellanti exists without tap hole only.
    result.priceContainers.push(createIdroBasinContainer(catalog, Meshes, brentaBasinFinishConfigMap, brentaTapHoleVariants))
    result.priceContainers.push(createOraniBasinContainer(catalog, Meshes, brentaBasinFinishConfigMap, brentaTapHoleVariants))
    result.priceContainers.push(createSerrentiBasinContainer(catalog, Meshes, brentaTapHoleVariants))
    result.priceContainers.push(createBellantiBasinContainer(catalog, Meshes))

    //The taps are triggered by mesh presence (amount 2 on the 1200 vanity), the finish by the accessory finish variant of the tap family.
    //The containers are shared with the Tesima range, so the Brenta Busca and Lori tap meshes carry the same names (Imola: see below).
    result.priceContainers.push(createLoriTapsContainer(catalog, Meshes))
    //The Brenta Imola taps come from a different template than the Tesima ones, which is used elsewhere as well. Renaming its meshes to the
    //Tesima names would affect those other configurators, so the Brenta mesh names are used as triggers instead. Brenta has no 3 hole Imola.
    result.priceContainers.push(
        createImolaTapsContainer(catalog, Meshes, brentaImolaAccessoryFinishConfigMap, {
            monoBlock: "1111_imola_m_block_basin_tap_cw_Slotd_click_waste",
            threeHole: "Imola 3 Hole Basin Tap",
            wallMount: "1167 - Imola W-Mount Basin Tap c-w Slot'd Click Waste",
        }),
    )
    result.priceContainers.push(createBuscaTapsContainer(catalog, Meshes, brentaBuscaFinishSuffixMap))

    //The mirrors are triggered by mesh presence (the 1200 vanity places two plain Vittoria meshes). Lixa and Ferno use the shared mirror
    //container. The framed Vittoria (600 only) has one mesh for both frames; the template takes the frame finish from the accessory finish
    //group of the selected tap and offers the frame for black and brass only (choosing chrome removes the frame). The brass frame is the
    //catalog "Gold" Vittoria 3835 (customer).
    result.priceContainers.push(createMirrorContainer(catalog, Meshes))
    result.priceContainers.push(createVelasMirrorContainer(catalog, Meshes))
    result.priceContainers.push(
        createVittoriaMirrorContainer(catalog, Meshes, {
            gold: [[BrentaBuscaAccessoryFinish, "brass"]],
            black: [
                [BrentaBuscaAccessoryFinish, "black"],
                [BrentaImolaAccessoryFinish, "black"],
            ],
        }),
    )

    //The additional units are triggered by mesh presence (the Additional Units variant adds the meshes), the finish of the wall unit and the
    //WC unit by the furniture finish variant. The configurator offers the WC unit in the six Brenta finishes, not in Adriatic Blue.
    //The WC unit comes with the Riverdale pan and the compact concealed cistern (customer). The cistern's flush button takes the accessory
    //finish of the selected tap group; the chrome button is included, black and brass buttons are priced on top (as for Levanto / Petra).
    result.priceContainers.push(createBrentaWallUnitContainer(catalog, Meshes, brentaFurnitureFinishConfigMap))
    result.priceContainers.push(createQuadraWcUnitContainer(catalog, Meshes, brentaFurnitureFinishConfigMap, 6, ["Adriatic Blue"]))
    result.priceContainers.push(createRiverdaleBtwPanContainer(catalog, Meshes))
    result.priceContainers.push(
        createCompactConcealedCisternContainer(catalog, Meshes, "3099LF - Compact Concealed Cistern Round Push Button copy", {
            mattBlack: [
                [BrentaBuscaAccessoryFinish, "black"],
                [BrentaImolaAccessoryFinish, "black"],
            ],
            brushedBrass: [[BrentaBuscaAccessoryFinish, "brass"]],
        }),
    )

    return result
}

export function createDiamanteGraph(catalog: CalypsoCatalog): PriceGraphData {
    const result: PriceGraphData = {
        amountGroups: [],
        pricedItemNodes: [],
        priceContainers: [],
    }

    //The vanity units are triggered by mesh presence, the finish by the furniture finish variant. Both must hold for a node to price.
    const diamante600Amount = new MeshAmountNode({parameters: {name: "5666 - Diamante 600", meshes: Meshes}})
    const diamante600Units = createVariantConditionedPriceNodes(catalog, "5666", 3, furnitureFinishConfigMap, diamante600Amount)

    const diamante800Amount = new MeshAmountNode({parameters: {name: "5667 - Diamante 800", meshes: Meshes}})
    const diamante800Units = createVariantConditionedPriceNodes(catalog, "5667", 3, furnitureFinishConfigMap, diamante800Amount)

    const diamante1000Amount = new MeshAmountNode({parameters: {name: "5668 - Diamante 1000", meshes: Meshes}})
    const diamante1000Units = createVariantConditionedPriceNodes(catalog, "5668", 3, furnitureFinishConfigMap, diamante1000Amount)

    const diamante1200Amount = new MeshAmountNode({parameters: {name: "5669 - Diamante 1200", meshes: Meshes}})
    const diamante1200Units = createVariantConditionedPriceNodes(catalog, "5669", 3, furnitureFinishConfigMap, diamante1200Amount)

    result.priceContainers.push(
        createPriceContainer("Vanity Units", "Vanity Units", [...diamante600Units, ...diamante800Units, ...diamante1000Units, ...diamante1200Units], true),
    )

    const calypstone600Amount = new MeshAmountNode({parameters: {name: "3840_-_Diamante_Vanity_Worktop_-_Calypstone_600_x_500_x_18mm", meshes: Meshes}})
    const calypstone600Units = createVariantConditionedPriceNodes(catalog, "3840", 3, calypstoneFinishConfigMap, calypstone600Amount)

    const calypstone800Amount = new MeshAmountNode({parameters: {name: "3268_-_Diamante_Vanity_Worktop_-_Calypstone_800_x_500_x_18mm", meshes: Meshes}})
    const calypstone800Units = createVariantConditionedPriceNodes(catalog, "3268", 3, calypstoneFinishConfigMap, calypstone800Amount)

    result.priceContainers.push(createPriceContainer("Worktops", "Worktops", [...calypstone600Units, ...calypstone800Units], true))

    result.priceContainers.push(createAlleronaBasinContainer(catalog, Meshes))
    result.priceContainers.push(createToledoBasinContainer(catalog, Meshes, BasinFinish))
    result.priceContainers.push(createIndianaBasinContainer(catalog, Meshes, BasinFinish))
    result.priceContainers.push(createDakotaBasinContainer(catalog, Meshes))
    result.priceContainers.push(createBouroBasinContainer(catalog, Meshes))
    result.priceContainers.push(createBellantiBasinContainer(catalog, Meshes))
    result.priceContainers.push(createDiamanteTallWallUnitContainer(catalog, Meshes, furnitureFinishConfigMap))

    result.priceContainers.push(createMirrorContainer(catalog, Meshes))
    result.priceContainers.push(createMarbellaMirrorContainer(catalog, Meshes, diamanteUltimoMirrorFrame, marbellaFrameFinishVariants))

    result.priceContainers.push(createLoriTapsContainer(catalog, Meshes))
    result.priceContainers.push(createMelfiTapsContainer(catalog, Meshes))
    result.priceContainers.push(createImolaTapsContainer(catalog, Meshes, accessoryFinishConfigMap))
    result.priceContainers.push(createFieraTapsContainer(catalog, Meshes, accessoryFinishConfigMap))
    result.priceContainers.push(createEulaTapsContainer(catalog, Meshes, accessoryFinishConfigMap))
    result.priceContainers.push(createBuscaTapsContainer(catalog, Meshes, buscaFinishSuffixMap))
    result.priceContainers.push(createAquilaTapsContainer(catalog, Meshes, accessoryFinishConfigMap))
    result.priceContainers.push(createLonatoTapsContainer(catalog, Meshes, accessoryFinishConfigMap))

    return result
}

//The template has one furniture finish group per vanity front (same group id, shared variant ids): smooth offers six finishes, fluted five.
//Only one of them is active at a time, so one node and one map cover both fronts.
let LevantoFurnitureFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "vanity_finish_",
        groupName: "Furniture Finish",
        currentVariant: {groupId: "vanity_finish_", groupName: "Furniture Finish", variantId: "coral_white", variantName: "Coral White"},
        allVariants: [],
    },
})
//porcelain_white, Porcelain White (smooth)
//coral_white, Coral White
//tortona_oak, Tortona Oak
//fir_green, Fir Green
//graphite, Graphite
//ember_gloss, Ember Gloss (smooth)
//persian_walnut, Persian Walnut (fluted)

const levantoFurnitureFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Porcelain White", [LevantoFurnitureFinish, "porcelain_white"]],
    ["Coral White", [LevantoFurnitureFinish, "coral_white"]],
    ["Tortona Oak", [LevantoFurnitureFinish, "tortona_oak"]],
    ["Fir Green", [LevantoFurnitureFinish, "fir_green"]],
    ["Graphite", [LevantoFurnitureFinish, "graphite"]],
    ["Ember Gloss", [LevantoFurnitureFinish, "ember_gloss"]],
    ["Persian Walnut", [LevantoFurnitureFinish, "persian_walnut"]],
])

//The template has one worktop finish group per worktop/basin combination (same group id and variants); only one is active at a time.
let LevantoWorktopFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "worktop_finish_",
        groupName: "Worktop Finish",
        currentVariant: {groupId: "worktop_finish_", groupName: "Worktop Finish", variantId: "porcelain_white", variantName: "Porcelain White"},
        allVariants: [],
    },
})
//porcelain_white, Porcelain White
//tortona_oak, Tortona Oak

const levantoWorktopFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Porcelain White", [LevantoWorktopFinish, "porcelain_white"]],
    ["Tortona Oak", [LevantoWorktopFinish, "tortona_oak"]],
])

let LevantoOrtaBasinColour = new ConfigurationGroupNode({
    parameters: {
        groupId: "orta_basin_finish",
        groupName: "Basin Colour",
        currentVariant: {groupId: "orta_basin_finish", groupName: "Basin Colour", variantId: "white", variantName: "White 1TH"},
        allVariants: [],
    },
})
//white, White 1TH
//black, Black 1TH

//The template has two Indiana basin colour groups (same group id and variants); only one is active at a time.
let LevantoIndianaBasinColour = new ConfigurationGroupNode({
    parameters: {
        groupId: "indiana_basin_finish_",
        groupName: "Basin Colour",
        currentVariant: {groupId: "indiana_basin_finish_", groupName: "Basin Colour", variantId: "_white", variantName: "White"},
        allVariants: [],
    },
})
//_white, White
//matt_black, Matt Black

const levantoIndianaBasinColourConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["White", [LevantoIndianaBasinColour, "_white"]],
    ["Matt Black", [LevantoIndianaBasinColour, "matt_black"]],
])

//The Farra basins have their own tap group; its variant decides between the one tap hole and no tap hole SKUs.
let LevantoFarraTap = new ConfigurationGroupNode({
    parameters: {
        groupId: "tap_inset_farra",
        groupName: "Tap",
        currentVariant: {groupId: "tap_inset_farra", groupName: "Tap", variantId: "inset_eula", variantName: "Eula"},
        allVariants: [],
    },
})
//inset_eula, Eula
//inset_imola, Imola
//inset_imola_wall, Imola Wall Mounted

//The template has one accessory finish group per tap family with different group ids: chrome_brass_black (Eula, Busca) and chrome_black
//(Imola). Each tap container gets its own map.
let LevantoChromeBrassBlackFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "chrome_brass_black",
        groupName: "Accessory Finish",
        currentVariant: {groupId: "chrome_brass_black", groupName: "Accessory Finish", variantId: "chrome", variantName: "Chrome"},
        allVariants: [],
    },
})
//chrome, Chrome
//brass, Brass
//black, Black

let LevantoChromeBlackFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "chrome_black",
        groupName: "Accessory Finish",
        currentVariant: {groupId: "chrome_black", groupName: "Accessory Finish", variantId: "chrome", variantName: "Chrome"},
        allVariants: [],
    },
})
//chrome, Chrome
//black, Black

const levantoEulaAccessoryFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Chrome", [LevantoChromeBrassBlackFinish, "chrome"]],
    ["Brushed Brass", [LevantoChromeBrassBlackFinish, "brass"]],
    ["Matt Black", [LevantoChromeBrassBlackFinish, "black"]],
])

//The Busca taps are resolved by SKU suffix (see createBuscaTapsContainer). The "brass" variant prices the natural brushed brass row
//(customer decision, 2026-09-16: "Brushed Brass" is replaced by "Natural Brushed Brass"); gunmetal and brushed bronze are not offered.
const levantoBuscaFinishSuffixMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["CHR", [LevantoChromeBrassBlackFinish, "chrome"]],
    ["NBB", [LevantoChromeBrassBlackFinish, "brass"]],
    ["MBK", [LevantoChromeBrassBlackFinish, "black"]],
])

const levantoImolaAccessoryFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Chrome", [LevantoChromeBlackFinish, "chrome"]],
    ["Matt Black", [LevantoChromeBlackFinish, "black"]],
])

//Mapping status and decisions: levanto.mapping.md
export function createLevantoGraph(catalog: CalypsoCatalog): PriceGraphData {
    const result: PriceGraphData = {
        amountGroups: [],
        pricedItemNodes: [],
        priceContainers: [],
    }

    //The vanity units are triggered by mesh presence, the finish by the furniture finish variant. Every size, front and basin location has
    //its own mesh carrying the kit SKU, so no size, front or location dependency is needed. The kits are priced, not their components
    //(vanity 5536/5829, complement units, glass shelf).
    const levantoVanityUnits = [
        {sku: "7810", finishCount: 6, meshName: "7810 - Levanto WH Vanity Unit 690mm"},
        {sku: "7878", finishCount: 6, meshName: "7878 - Levanto WH Wing Vanity Set 1040mm For LH Bowl Basin"},
        {sku: "7879", finishCount: 6, meshName: "7879 - Levanto WH Wing Vanity Set 1040mm For RH Bowl Basin"},
        {sku: "7880", finishCount: 6, meshName: "7880 - Levanto WH Double Wing Vanity Unit 1375mm For Centre Bowl Basin"},
        {sku: "7890", finishCount: 5, meshName: "7890 - Levanto Fluted WH Vanity Unit 690mm"},
        {sku: "7891", finishCount: 5, meshName: "7891 - Levanto Fluted WH Wing Vanity Set 1040mm For LH Bowl Basin"},
        {sku: "7892", finishCount: 5, meshName: "7892 - Levanto Fluted WH Wing Vanity Set 1040mm For RH Bowl Basin"},
        {sku: "7893", finishCount: 5, meshName: "7893 - Levanto Fluted WH Double Wing Vanity Set 1375mm For Centre Bowl Basin"},
    ].flatMap(({sku, finishCount, meshName}) =>
        createVariantConditionedPriceNodes(
            catalog,
            sku,
            finishCount,
            levantoFurnitureFinishConfigMap,
            new MeshAmountNode({parameters: {name: meshName, meshes: Meshes}}),
        ),
    )
    result.priceContainers.push(createPriceContainer("Vanity Units", "Vanity Units", levantoVanityUnits, true))

    //The worktops only exist with the sit-on basins (Indiana, Vinci) and are triggered by mesh presence, the finish by the worktop finish
    //variant. The parsed descriptions of the 1040 LH and RH basin worktops are identical (the parser drops desc3), so the exact SKU stems
    //are used. The 1380 worktop has one SKU per finish (5785, 5789) without suffix.
    const levantoWorktop1040LhAmount = new MeshAmountNode({parameters: {name: "5784 - 1040mm Left Hand Basin Vanity Worktop", meshes: Meshes}})
    const levantoWorktop1040LhUnits = createVariantConditionedPriceNodes(catalog, "5784", 2, levantoWorktopFinishConfigMap, levantoWorktop1040LhAmount)

    const levantoWorktop1040RhAmount = new MeshAmountNode({parameters: {name: "5784 - 1040mm Right Hand Basin Vanity Worktop", meshes: Meshes}})
    const levantoWorktop1040RhUnits = createVariantConditionedPriceNodes(catalog, "5783", 2, levantoWorktopFinishConfigMap, levantoWorktop1040RhAmount)

    const levantoWorktop1380Amount = new MeshAmountNode({parameters: {name: "Levanto Double Wing Vanity Worktop", meshes: Meshes}})
    const levantoWorktop1380Units = createVariantConditionedPriceNodes(
        catalog,
        "Worktop - Levanto Double Wing",
        2,
        levantoWorktopFinishConfigMap,
        levantoWorktop1380Amount,
    )

    result.priceContainers.push(
        createPriceContainer("Worktops", "Worktops", [...levantoWorktop1040LhUnits, ...levantoWorktop1040RhUnits, ...levantoWorktop1380Units], true),
    )

    //The basins are triggered by mesh presence. Orta: white/black by the basin colour. Farra: one tap hole for the deck mounted taps, no tap
    //hole for the wall mounted tap. Indiana: white/matt black by its own basin colour group. Vinci: single finish.
    result.priceContainers.push(createOrtaBasinContainer(catalog, Meshes, {group: LevantoOrtaBasinColour, white: "white", black: "black"}))
    result.priceContainers.push(
        createFarraBasinContainer(catalog, Meshes, {group: LevantoFarraTap, oneTapHole: ["inset_eula", "inset_imola"], noTapHole: ["inset_imola_wall"]}),
    )
    result.priceContainers.push(createIndianaBasinContainer(catalog, Meshes, levantoIndianaBasinColourConfigMap))
    result.priceContainers.push(createVinciBasinContainer(catalog, Meshes))

    //The taps are triggered by mesh presence, the finish by the accessory finish group of the tap family. The Eula and Busca meshes carry
    //the Tesima names, the Imola meshes the Brenta names (same Imola template). Levanto has no 3 hole Imola and no Busca mono tap.
    result.priceContainers.push(createEulaTapsContainer(catalog, Meshes, levantoEulaAccessoryFinishConfigMap))
    result.priceContainers.push(
        createImolaTapsContainer(catalog, Meshes, levantoImolaAccessoryFinishConfigMap, {
            monoBlock: "1111_imola_m_block_basin_tap_cw_Slotd_click_waste",
            threeHole: "Imola 3 Hole Basin Tap",
            wallMount: "1167 - Imola W-Mount Basin Tap c-w Slot'd Click Waste",
        }),
    )
    result.priceContainers.push(createBuscaTapsContainer(catalog, Meshes, levantoBuscaFinishSuffixMap))

    //The mirrors are triggered by mesh presence (every Ostra size has its own mesh, renamed to the shared names). The Murello frame follows
    //the brass accessory finish of the Eula/Busca group.
    result.priceContainers.push(createMirrorContainer(catalog, Meshes))
    result.priceContainers.push(createOrbaMirrorContainer(catalog, Meshes))
    result.priceContainers.push(createMurelloMirrorContainer(catalog, Meshes, [LevantoChromeBrassBlackFinish, "brass"]))

    //The additional units are triggered by mesh presence (the Additional Units variant adds the meshes), the finish of the wall unit and the
    //WC unit by the furniture finish variant. The meshes carry the Ultimo (Forino, Rimella) and Brenta (pan, cistern) trigger names. The
    //Rimella WC unit is offered in seven finishes (smooth six + Persian Walnut), not in Soft Linen. The WC unit is priced as unit + pan +
    //cistern (user decision); the cistern includes the chrome button, black and brass buttons follow the accessory finish of either tap group.
    result.priceContainers.push(createForinoWallUnitContainer(catalog, Meshes, levantoFurnitureFinishConfigMap, {fluted: 5, smooth: 6}))
    result.priceContainers.push(createRimellaWcUnitContainer(catalog, Meshes, levantoFurnitureFinishConfigMap, 7, ["Soft Linen"]))
    result.priceContainers.push(createRiverdaleBtwPanContainer(catalog, Meshes))
    result.priceContainers.push(
        createCompactConcealedCisternContainer(catalog, Meshes, "3099LF - Compact Concealed Cistern Round Push Button copy", {
            mattBlack: [
                [LevantoChromeBrassBlackFinish, "black"],
                [LevantoChromeBlackFinish, "black"],
            ],
            brushedBrass: [[LevantoChromeBrassBlackFinish, "brass"]],
        }),
    )

    return result
}

let PetraFurnitureFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "vanity-finish",
        groupName: "Furniture Finish",
        currentVariant: {groupId: "vanity-finish", groupName: "Furniture Finish", variantId: "soft-linen", variantName: "Soft Linen"},
        allVariants: [],
    },
})
//soft-linen, Soft Linen
//tortona-oak, Tortona Oak
//persian-walnut, Persian Walnut

const petraFurnitureFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Soft Linen", [PetraFurnitureFinish, "soft-linen"]],
    ["Tortona Oak", [PetraFurnitureFinish, "tortona-oak"]],
    ["Persian Walnut", [PetraFurnitureFinish, "persian-walnut"]],
])

//The template has one solid surface worktop finish group per worktop (same group id and variants); only the one of the placed worktop is
//active. Same group id as the Brenta worktop finish, but different variants.
let PetraSolidSurfaceFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "undermount-worktop-finish",
        groupName: "Worktop Finish",
        currentVariant: {groupId: "undermount-worktop-finish", groupName: "Worktop Finish", variantId: "gold-calacatta", variantName: "Gold Calacatta"},
        allVariants: [],
    },
})
//gold-calacatta, Gold Calacatta
//nero-marquina, Nero Marquina
//white-stone, White Stone
//desert-sand, Desert Sand

const petraSolidSurfaceFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Gold Calacatta", [PetraSolidSurfaceFinish, "gold-calacatta"]],
    ["Nero Marquina", [PetraSolidSurfaceFinish, "nero-marquina"]],
    ["White Stone", [PetraSolidSurfaceFinish, "white-stone"]],
    ["Desert Sand", [PetraSolidSurfaceFinish, "desert-sand"]],
])

//The template has one colour matched worktop finish group per worktop size (same group id and variants); only one is active at a time.
let PetraWorktopFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "petra-worktop-finish",
        groupName: "Worktop Finish",
        currentVariant: {groupId: "petra-worktop-finish", groupName: "Worktop Finish", variantId: "tortona_oak", variantName: "Tortona Oak"},
        allVariants: [],
    },
})
//tortona_oak, Tortona Oak
//persian_walnut, Persian Walnut

const petraWorktopFinishConfigMap = new Map<string, [ConfigurationGroupNode, string]>([
    ["Tortona Oak", [PetraWorktopFinish, "tortona_oak"]],
    ["Persian Walnut", [PetraWorktopFinish, "persian_walnut"]],
])

//The accessory finish is split into one group per handle design, since the designs offer different finishes. The groups share their
//variant ids and are never active together, so every finish-dependent item is conditioned on all three (funnel, Conditions.md case 2).
const createPetraAccessoryFinish = (groupId: string, variantId: string, variantName: string) =>
    new ConfigurationGroupNode({
        parameters: {
            groupId,
            groupName: "Accessory Finish",
            currentVariant: {groupId, groupName: "Accessory Finish", variantId, variantName},
            allVariants: [],
        },
    })
const PetraAccessoryFinishRenaico = createPetraAccessoryFinish("metal-finish-1", "brass", "Brass") //brass
const PetraAccessoryFinishFloresta = createPetraAccessoryFinish("metal-finish-2", "chrome", "Chrome") //chrome, brass
const PetraAccessoryFinishLucina = createPetraAccessoryFinish("metal-finish-3", "chrome", "Chrome") //chrome, brass, black
const petraAccessoryFinishGroups = [PetraAccessoryFinishRenaico, PetraAccessoryFinishFloresta, PetraAccessoryFinishLucina]

const petraAccessoryFinish: KeyedVariants = {
    groups: petraAccessoryFinishGroups,
    variantIdByKey: new Map([
        ["Chrome", "chrome"],
        ["Brushed Brass", "brass"],
        ["Matt Black", "black"],
    ]),
}

//Busca taps by SKU suffix (see createBuscaTapsContainer); brass prices the natural brushed brass row (customer decision, 2026-09-16).
const petraBuscaFinish: KeyedVariants = {
    groups: petraAccessoryFinishGroups,
    variantIdByKey: new Map([
        ["CHR", "chrome"],
        ["NBB", "brass"],
        ["MBK", "black"],
    ]),
    keyMatches: "skuSuffix",
}

//Handles by SKU suffix: the Lucina black row is "Black", not "Matt Black".
const petraHandleFinish: KeyedVariants = {
    groups: petraAccessoryFinishGroups,
    variantIdByKey: new Map([
        ["CHR", "chrome"],
        ["BBR", "brass"],
        ["BLK", "black"],
    ]),
    keyMatches: "skuSuffix",
}

//Marbella frame: the brass finish selects the gold frame, black the black frame (chrome shows the plain mirror).
const petraMarbellaFrameFinish: KeyedVariants = {
    groups: petraAccessoryFinishGroups,
    variantIdByKey: new Map([
        ["Gold", "brass"],
        ["Black", "black"],
    ]),
}

//Mapping status and decisions: petra.mapping.md
export function createPetraGraph(catalog: CalypsoCatalog): PriceGraphData {
    const result: PriceGraphData = {
        amountGroups: [],
        pricedItemNodes: [],
        priceContainers: [],
    }

    //The vanity units are triggered by mesh presence (one mesh per size), the finish by the furniture finish variant. The meshes were
    //renamed to the catalog SKUs (the template had 5845 / 5848, which don't exist in the catalog).
    const petra645Amount = new MeshAmountNode({parameters: {name: "5846 - Petra WH Vanity Unit 645 x 500 x 420mm Fluted", meshes: Meshes}})
    const petra645Units = createVariantConditionedPriceNodes(catalog, "5846", 3, petraFurnitureFinishConfigMap, petra645Amount)

    const petra985Amount = new MeshAmountNode({parameters: {name: "5849 - Petra WH Vanity Unit 985 x 500 x 420mm Fluted", meshes: Meshes}})
    const petra985Units = createVariantConditionedPriceNodes(catalog, "5849", 3, petraFurnitureFinishConfigMap, petra985Amount)

    result.priceContainers.push(createPriceContainer("Vanity Units", "Vanity Units", [...petra645Units, ...petra985Units], true))

    result.priceContainers.push(createPetraTallWallUnitContainer(catalog, Meshes, petraFurnitureFinishConfigMap))

    result.priceContainers.push(createPetraDecorLegsContainer(catalog, Meshes, petraFurnitureFinishConfigMap))

    //The worktops are triggered by mesh presence (one worktop mesh per basin type / worktop / size), the finish by the worktop finish
    //variant. The square edge worktops come with the undermount basin ("c/w UM Basin"), which is not priced separately. The square edge
    //worktops with tap hole (5881 / 5885, Nero Marquina only) are not used for now (user decision).
    const worktopAmount = (name: string) => new MeshAmountNode({parameters: {name, meshes: Meshes}})

    //Exact SKUs per finish: "5898" also finds P5898, which has the description of 5898DS but a different price (user: use 5898DS for now).
    const squareEdge645Amount = worktopAmount("5898 - Worktop (Solid Surface) - Square Edge 645 x 500 x 20mm c-w UM Basin")
    const squareEdge645Units = ["5898DS", "5898GC", "5898NM", "5898WN"].flatMap((sku) =>
        createVariantConditionedPriceNodes(catalog, sku, 1, petraSolidSurfaceFinishConfigMap, squareEdge645Amount),
    )

    const squareEdge985Amount = worktopAmount("5886 - Worktop (Solid Surface) - Square Edge 985 x 500 x 20mm c-w UM Basin")
    const squareEdge985Units = createVariantConditionedPriceNodes(catalog, "5886", 4, petraSolidSurfaceFinishConfigMap, squareEdge985Amount)

    const chamfered645Amount = worktopAmount("5879 - Worktop (Solid Surface) - Chamfered Edge 645 x 500 x 20mm")
    const chamfered645Units = createVariantConditionedPriceNodes(catalog, "5879", 4, petraSolidSurfaceFinishConfigMap, chamfered645Amount)

    const chamfered985Amount = worktopAmount("5883 - Worktop (Solid Surface) - Chamfered Edge 985 x 500 x 20mm")
    const chamfered985Units = createVariantConditionedPriceNodes(catalog, "5883", 4, petraSolidSurfaceFinishConfigMap, chamfered985Amount)

    //The 985 colour matched worktop has one SKU stem per finish (5854PN, 5858TOK), so both sizes are searched by description.
    const colourMatched645Amount = worktopAmount("5855 - Petra Colour Matched Worktop 645 x 500 x 16mm Chamfer Edged")
    const colourMatched645Units = createVariantConditionedPriceNodes(
        catalog,
        ["Colour Matched Worktop", "645"],
        2,
        petraWorktopFinishConfigMap,
        colourMatched645Amount,
    )

    const colourMatched985Amount = worktopAmount("5854 - Petra Colour Matched Worktop 985 x 500 x 16mm Chamfer Edged")
    const colourMatched985Units = createVariantConditionedPriceNodes(
        catalog,
        ["Colour Matched Worktop", "985"],
        2,
        petraWorktopFinishConfigMap,
        colourMatched985Amount,
    )

    result.priceContainers.push(
        createPriceContainer(
            "Worktops",
            "Worktops",
            [...squareEdge645Units, ...squareEdge985Units, ...chamfered645Units, ...chamfered985Units, ...colourMatched645Units, ...colourMatched985Units],
            true,
        ),
    )

    //sit-on basins: white only, no tap hole versions, priced by mesh presence
    result.priceContainers.push(createBouroBasinContainer(catalog, Meshes))
    result.priceContainers.push(createFloridaBasinContainer(catalog, Meshes))

    //taps: the wastes are included ("c/w … Waste"); only the mono Aquila exists in this template
    result.priceContainers.push(createBuscaTapsContainer(catalog, Meshes, petraBuscaFinish))
    result.priceContainers.push(
        createAquilaTapsContainer(catalog, Meshes, petraAccessoryFinish, {
            ...tesimaAquilaTapMeshNames,
            mono: "1144 - Aquila Mono Basin Tap c-w Slotted Waste_main",
        }),
    )

    result.priceContainers.push(createPetraHandlesContainer(catalog, Meshes, petraHandleFinish))

    //mirrors: triggered by mesh presence; the Marbella frame by the framed mesh and the accessory finish
    result.priceContainers.push(createAndrinaMirrorContainer(catalog, Meshes))
    result.priceContainers.push(createPetraMarbellaMirrorContainer(catalog, Meshes, petraMarbellaFrameFinish))
    result.priceContainers.push(createVelasMirrorContainer(catalog, Meshes))

    //WC unit as in Levanto: unit + pan + cistern (the meshes carry the shared trigger names). The Rimella comes in the three Petra furniture
    //finishes. The cistern includes the chrome button; brass and black buttons follow the active accessory finish group (one node each).
    result.priceContainers.push(
        createRimellaWcUnitContainer(catalog, Meshes, petraFurnitureFinishConfigMap, 3, [
            "Coral White",
            "Ember Gloss",
            "Fir Green",
            "Graphite",
            "Porcelain White",
        ]),
    )
    result.priceContainers.push(createRiverdaleBtwPanContainer(catalog, Meshes))
    result.priceContainers.push(
        createCompactConcealedCisternContainer(catalog, Meshes, "3099LF - Compact Concealed Cistern Round Push Button copy", {
            mattBlack: [[PetraAccessoryFinishLucina, "black"]],
            brushedBrass: petraAccessoryFinishGroups.map((group): [ConfigurationGroupNode, string] => [group, "brass"]),
        }),
    )

    return result
}

let ValorFurnitureFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "185ec4d4-b549-40bb-bca2-f951031bc903",
        groupName: "Furniture Finish",
        currentVariant: {
            groupId: "185ec4d4-b549-40bb-bca2-f951031bc903",
            groupName: "Furniture Finish",
            variantId: "52f49154-7f56-46f6-8770-dbab043e662e",
            variantName: "Opal White",
        },
        allVariants: [],
    },
})
//52f49154-7f56-46f6-8770-dbab043e662e, Opal White
//0e88b5f6-cce5-478c-8860-9ed94d546686, Natural Hessian
//89941554-37ae-4a08-bff3-08689a169d57, Cypress

let ValorFrameFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "10b72df9-e16e-4027-88f8-2039b98f7499",
        groupName: "Frame Finish",
        currentVariant: {
            groupId: "10b72df9-e16e-4027-88f8-2039b98f7499",
            groupName: "Frame Finish",
            variantId: "92a64648-d8cb-4468-b757-9707501af2ca",
            variantName: "Black",
        },
        allVariants: [],
    },
})
//92a64648-d8cb-4468-b757-9707501af2ca, Black
//280adbd7-02f0-4007-ae5c-e2117b39e3cd, Walnut

const valorFurnitureFinish: KeyedVariants = {
    groups: [ValorFurnitureFinish],
    variantIdByKey: new Map([
        ["Opal White", "52f49154-7f56-46f6-8770-dbab043e662e"],
        ["Natural Hessian", "0e88b5f6-cce5-478c-8860-9ed94d546686"],
        ["Cypress", "89941554-37ae-4a08-bff3-08689a169d57"],
    ]),
}

//Only the Indiana bowl has a basin finish; the variant ids are the SKUs (same group id as the Tesima BasinFinish).
let ValorBasinFinish = new ConfigurationGroupNode({
    parameters: {
        groupId: "basinfinish",
        groupName: "Basin Finish",
        currentVariant: {groupId: "basinfinish", groupName: "Basin Finish", variantId: "9317", variantName: "White"},
        allVariants: [],
    },
})
//9317, White
//9318, Matt Black

//The accessory finish is split into three groups with shared variant ids, exactly one of them active: the full one, a chrome-only one
//(active with the Melfi taps) and a brass/black one (active with the Murello mirror). They are read as one funnel.
const valorAccessoryFinishGroup = (groupId: string, variantId: string, variantName: string) =>
    new ConfigurationGroupNode({
        parameters: {
            groupId,
            groupName: "Accessory Finishes",
            currentVariant: {groupId, groupName: "Accessory Finishes", variantId, variantName},
            allVariants: [],
        },
    })
const valorAccessoryFinishGroups = [
    valorAccessoryFinishGroup("accsfin", "CHR", "Chrome"), //CHR, BBR (Natural Brushed Brass), BBZ, GML, BLK
    valorAccessoryFinishGroup("d9d48ebf-d583-4cba-9763-e2cca2be1bce", "CHR", "Chrome"), //CHR
    valorAccessoryFinishGroup("7d3c1505-38f3-4739-baa6-90e610a4a91b", "BBR", "Brushed Brass"), //BBR (Brushed Brass), BLK (Black)
]

//The Busca taps by SKU suffix; the brass variant prices the natural brushed brass row (customer decision, 2026-09-16).
const valorBuscaFinish: KeyedVariants = {
    groups: valorAccessoryFinishGroups,
    variantIdByKey: new Map([
        ["CHR", "CHR"],
        ["NBB", "BBR"],
        ["MBK", "BLK"],
        ["GML", "GML"],
        ["BBZ", "BBZ"],
    ]),
    keyMatches: "skuSuffix",
}

//The Marbella frame (set by the template to "With Frame" for brass and black, absent otherwise) and the Murello frame follow the accessory
//finish funnel; the brass frame prices as the gold Marbella.
const valorMarbellaFrame = {
    group: new ConfigurationGroupNode({
        parameters: {
            groupId: "bc8714fa-74c6-4981-92cd-9dbe5b751796",
            groupName: "Mirror Frame",
            currentVariant: {
                groupId: "bc8714fa-74c6-4981-92cd-9dbe5b751796",
                groupName: "Mirror Frame",
                variantId: "876d7308-b78d-4e30-ae41-ada9653a4cbd",
                variantName: "Plain",
            },
            allVariants: [],
        },
    }),
    withFrameVariantId: "a5f7d8c9-b549-46be-b699-c851dce5689d",
}

const valorMarbellaFrameFinish: KeyedVariants = {
    groups: valorAccessoryFinishGroups,
    variantIdByKey: new Map([
        ["Gold", "BBR"],
        ["Black", "BLK"],
    ]),
}

const valorMurelloFinish: KeyedVariants = {
    groups: valorAccessoryFinishGroups,
    variantIdByKey: new Map([
        ["Brushed Brass", "BBR"],
        ["Black", "BLK"],
    ]),
}

//The cistern includes the chrome flush button; the other accessory finishes add their button on top.
const valorFlushButtonFinish: KeyedVariants = {
    groups: valorAccessoryFinishGroups,
    variantIdByKey: new Map([
        ["Matt Black", "BLK"],
        ["Brushed Brass", "BBR"],
        ["Brushed Bronze", "BBZ"],
        ["Gunmetal", "GML"],
    ]),
}

const valorBlackFrame = variantSelected(ValorFrameFinish, "92a64648-d8cb-4468-b757-9707501af2ca")
const valorWalnutFrame = variantSelected(ValorFrameFinish, "280adbd7-02f0-4007-ae5c-e2117b39e3cd")

//Mapping status and decisions: valor.mapping.md
export function createValorGraph(catalog: CalypsoCatalog): PriceGraphData {
    const result: PriceGraphData = {
        amountGroups: [],
        pricedItemNodes: [],
        priceContainers: [],
    }

    //The vanity units are sold as kits including the leg frames (user decision), one kit family per vanity and frame finish. The vanity is
    //triggered by its mesh (named after the carcass SKU, which doesn't depend on the frame), the furniture finish selects the catalog row
    //and the frame finish the kit family. The two families differ only in desc3 ("c/w Black / Walnut Frame"), which the parser drops, so
    //they are searched by SKU stem.
    const valorVanityUnits = [
        {meshName: "4100 - Valor Vanity 600, 1 Drawer", blackFrameKit: "6961", walnutFrameKit: "6965"},
        {meshName: "4103 - Valor Vanity 800, 1 Drawer", blackFrameKit: "6962", walnutFrameKit: "6966"},
        {meshName: "4106 - Valor Vanity 600, 2 Drawer", blackFrameKit: "6963", walnutFrameKit: "6967"},
        {meshName: "4109 - Valor Vanity 800, 2 Drawer", blackFrameKit: "6964", walnutFrameKit: "6968"},
    ].flatMap(({meshName, blackFrameKit, walnutFrameKit}) => {
        const amount = new MeshAmountNode({parameters: {name: meshName, meshes: Meshes}})
        return [
            ...createKeyedVariantPriceNodes(catalog, blackFrameKit, 3, valorFurnitureFinish, {amount, condition: valorBlackFrame}),
            ...createKeyedVariantPriceNodes(catalog, walnutFrameKit, 3, valorFurnitureFinish, {amount, condition: valorWalnutFrame}),
        ]
    })
    result.priceContainers.push(createPriceContainer("Vanity Units", "Vanity Units", valorVanityUnits, true))

    //The tall wall unit is triggered by its mesh (added by the Additional Units variant; the position only moves it), the finish by the
    //furniture finish variant. The frame finish doesn't apply to it.
    const valorTallWallUnitAmount = new MeshAmountNode({parameters: {name: "4130 - Valor Tall Wall Unit", meshes: Meshes}})
    const valorTallWallUnits = createKeyedVariantPriceNodes(catalog, "4130", 3, valorFurnitureFinish, {amount: valorTallWallUnitAmount})
    result.priceContainers.push(createPriceContainer("Tall Wall Unit", "Tall Wall Unit", valorTallWallUnits, true))

    //The cast marble worktops come with the sit-on bowls (Tahoma, Indiana) only and exist in one finish. The meshes are named after the
    //bare SKU (user decision: no rename); the two sub-template copies carry the same names but are never in a scene together.
    const valorWorktop600 = createAmountTriggeredPriceNode(catalog, "3289", new MeshAmountNode({parameters: {name: "3289", meshes: Meshes}}))
    const valorWorktop800 = createAmountTriggeredPriceNode(catalog, "3290", new MeshAmountNode({parameters: {name: "3290", meshes: Meshes}}))
    result.priceContainers.push(createPriceContainer("Worktops", "Worktops", [valorWorktop600, valorWorktop800], true))

    //The basins are triggered by their meshes (one per basin and size). Only the Indiana bowl has a finish, selected by the basin finish
    //variant whose ids are the SKUs. The wastes follow the accessory finish but are included in the taps ("c/w … Waste").
    const valorBasinAmount = (name: string) => new MeshAmountNode({parameters: {name, meshes: Meshes}})
    const valorPanama600 = createAmountTriggeredPriceNode(catalog, "9315", valorBasinAmount("9315 - Panama Ceramic Vanity Basin 610 x 460 x 75mm"))
    const valorPanama800 = createAmountTriggeredPriceNode(catalog, "9316", valorBasinAmount("9316 - Panama Ceramic Vanity Basin 810 x 460 x 75mm"))
    const valorTahoma = createAmountTriggeredPriceNode(catalog, "9319", valorBasinAmount("9319 - Tahoma Ceramic Sit-On Bowl 420 dia x 120 Tap Hole"))
    const valorIndianaUnits = createConditionedPriceNodes(
        catalog,
        "Indiana",
        2,
        (item) => variantSelected(ValorBasinFinish, item.uniqueId),
        valorBasinAmount("9317 - Indiana Ceramic Sit-On Bowl 360 dia x 120 Fluted"),
    )
    const valorMeda = createAmountTriggeredPriceNode(catalog, "9280", valorBasinAmount("9280 - Meda Cast Vanity Basin 810 x 460 x 15mm"))
    result.priceContainers.push(createPriceContainer("Basins", "Basins", [valorPanama600, valorPanama800, valorTahoma, ...valorIndianaUnits, valorMeda], true))

    //The taps are triggered by their meshes (shared trigger names), the Busca finish by the accessory finish funnel. Melfi is chrome only.
    result.priceContainers.push(createBuscaTapsContainer(catalog, Meshes, valorBuscaFinish))
    result.priceContainers.push(createMelfiTapsContainer(catalog, Meshes))

    //The mirrors are triggered by their meshes (shared trigger names; one mesh per size). Camino and Ostuni exist in one finish.
    result.priceContainers.push(createMirrorContainer(catalog, Meshes))
    result.priceContainers.push(createMarbellaMirrorContainer(catalog, Meshes, valorMarbellaFrame, valorMarbellaFrameFinish))
    result.priceContainers.push(createMurelloMirrorContainer(catalog, Meshes, valorMurelloFinish))

    //The WC unit is priced as unit + pan + cistern (user decision, as Brenta / Levanto), all triggered by their meshes (added by the
    //Additional Units variant; the position only moves them). The unit's finish follows the furniture finish, the flush button's the
    //accessory finish funnel.
    const valorWcUnitAmount = new MeshAmountNode({parameters: {name: "4127 - Valor WC Unit 500 x 225 x 829mm", meshes: Meshes}})
    const valorWcUnits = createKeyedVariantPriceNodes(catalog, "4127", 3, valorFurnitureFinish, {amount: valorWcUnitAmount})
    const valorPanAmount = new MeshAmountNode({parameters: {name: "36.9322.01 - Daytona BTW Pan c-w Borden SC Seat", meshes: Meshes}})
    const valorPan = createAmountTriggeredPriceNode(catalog, "36.9322.01", valorPanAmount)
    result.priceContainers.push(createPriceContainer("WC Unit", "WC Unit", [...valorWcUnits, valorPan], true))
    result.priceContainers.push(
        createCompactConcealedCisternContainer(catalog, Meshes, "3099LF - Compact Concealed Cistern Round Push Button copy", valorFlushButtonFinish),
    )

    return result
}
